import { SELECT_TAB } from '../actions/ActionTypes';
import { FORECAST } from '../constants/Tabs';
const initialState = {
  selectedTab: FORECAST
};
export default ((state = initialState, action) => {
  switch (action.type) {
    case SELECT_TAB:
      return Object.assign({}, state, {
        selectedTab: action.payload
      });
    default:
      return state;
  }
});